import { SocketService } from '../../../notification/event-centre/core/socket.service';
import { epicDependencies } from '../../../store';

export function teardownBindings(): void {
    const socketService =
        epicDependencies.injector.get<SocketService>(SocketService);

    socketService.off('OnProgress');
}
